import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "@/lib/scroll";

const Block = ({ title, children }) => (
  <section className="border-t border-white/10 pt-8 mt-8 first:border-t-0 first:pt-0 first:mt-0">
    <h2 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">{title}</h2>
    <div className="mt-4 space-y-3 text-sm md:text-base leading-relaxed text-white/60">{children}</div>
  </section>
);

export const LegalShell = ({ title, subtitle, testid, children }) => (
  <div className="bg-ink text-white min-h-screen flex flex-col">
    <Header />
    <main className="flex-1 mx-auto w-full max-w-3xl px-5 md:px-8 pt-36 pb-24" data-testid={testid}>
      <Link
        data-testid="legal-back-link"
        to="/"
        className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-brand-bright hover:text-white transition-colors duration-300"
      >
        <ArrowLeft className="h-4 w-4" /> ZURÜCK ZUR STARTSEITE
      </Link>
      <h1 className="mt-8 font-display text-4xl md:text-6xl font-bold uppercase tracking-tighter">{title}</h1>
      {subtitle && <p className="mt-4 text-sm font-semibold tracking-wide text-white/40">{subtitle}</p>}
      <div className="mt-12">{children}</div>
    </main>
    <Footer />
  </div>
);

export function Impressum() {
  return (
    <LegalShell title="Impressum" testid="impressum-page">
      <Block title="Angaben gemäß § 5 TMG">
        <p className="font-bold text-white">Terbeck Service GbR</p>
        <p>Julian Rehers</p>
        <p>Riekenhofweg 29</p>
        <p>48599 Gronau (Westf.)</p>
      </Block>
      <Block title="Kontakt">
        <p>
          Telefon: <a href={PHONE_TEL} className="text-brand-bright hover:underline">{PHONE_DISPLAY}</a>
        </p>
        <p>
          E-Mail: <a href={`mailto:${EMAIL}`} className="text-brand-bright hover:underline">{EMAIL}</a>
        </p>
      </Block>
      <Block title="Vertretungsberechtigt">
        <p>Julian Rehers (Gesellschafter)</p>
      </Block>
      <Block title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
        <p>Julian Rehers, Anschrift wie oben</p>
      </Block>
    </LegalShell>
  );
}

export function Datenschutz() {
  return (
    <LegalShell title="Datenschutz" subtitle="Datenschutzerklärung der Terbeck Service GbR" testid="datenschutz-page">
      <Block title="1. Verantwortlicher">
        <p className="font-bold text-white">Terbeck Service GbR, Julian Rehers</p>
        <p>Riekenhofweg 29, 48599 Gronau (Westf.)</p>
        <p>
          Telefon: <a href={PHONE_TEL} className="text-brand-bright hover:underline">{PHONE_DISPLAY}</a> ·
          E-Mail: <a href={`mailto:${EMAIL}`} className="text-brand-bright hover:underline"> {EMAIL}</a>
        </p>
      </Block>
      <Block title="2. Erhebung und Verarbeitung von Daten">
        <p>
          Bei Nutzung unseres Kontaktformulars verarbeiten wir die von Ihnen angegebenen Daten
          (Name, Telefonnummer, E-Mail-Adresse, gewünschte Leistung und Nachricht) ausschließlich
          zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO). Eine Weitergabe an Dritte
          erfolgt nicht.
        </p>
      </Block>
      <Block title="3. Speicherdauer">
        <p>
          Ihre Daten werden nur so lange gespeichert, wie es für die Bearbeitung Ihrer Anfrage
          erforderlich ist, beziehungsweise gesetzliche Aufbewahrungspflichten bestehen.
        </p>
      </Block>
      <Block title="4. Ihre Rechte">
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
          Datenübertragbarkeit sowie Widerspruch. Wenden Sie sich hierzu an die oben genannten
          Kontaktdaten. Zudem besteht ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.
        </p>
      </Block>
    </LegalShell>
  );
}

export default LegalShell;
